



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component
export default class TermsAndConditionModal extends Vue {
  @Prop({ default: () => {} }) onAcceptTermsAndCondition;
  get appTheme() {
    return vxm.utility.AppTheme;
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE');
  }
}
